import React from 'react';
import image from 'assets/images/admin-forgot-password.png';
import { Col, Image, Row, Typography } from 'components';
import { ResetPasswordForm, ResetPasswordFormData } from 'components/auth';
import styles from '../signIn/styles.module.scss';
import { useAdminResetPassword } from './useResetPassword';
import InvalidResetToken from './InvalidResetToken';

const { Text } = Typography;

export const AdminResetPassword = React.memo(() => {
  const { onFinish, contextHolder, form, invalidToken, isLoading } = useAdminResetPassword();

  const customPasswordValidation = async (value: string) => {
    if (!value || value.trim().length >= 12) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Password must be at least 12 characters long.'));
  };

  const handleFormSubmit = (values: ResetPasswordFormData) => {
    onFinish({
      password: values.password,
      passwordRepeat: values.passwordRepeat,
    } as any);
  };
  return (
    <>
      {contextHolder}
      <Row wrap={true} className={styles.signup} align={'middle'}>
        <Col lg={12} md={24}>
          <Row justify={'center'} className={styles.left_side}>
            <Col sm={15} xs={24} className={styles.form}>
              {invalidToken ? (
                <InvalidResetToken />
              ) : (
                <Row gutter={[0, 24]}>
                  <Col span={24}>
                    <Text className={styles.title}>Set up a Password</Text>
                  </Col>
                  <Col span={24}>
                    <Text className={styles.description}>Please create a new password for your account.</Text>
                  </Col>
                  <Col span={24}>
                    <ResetPasswordForm
                      form={form}
                      onFinish={handleFormSubmit}
                      loading={isLoading}
                      submitButtonText="Set up Password"
                      showBackToLogin={false}
                      customPasswordValidation={customPasswordValidation}
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
        <Col lg={12} md={24}>
          <Row className={styles.right_side}>
            <Image src={image} alt={'image'} preview={false} width={'100%'} />
          </Row>
        </Col>
      </Row>
    </>
  );
});
